import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const navItems = [
  { label: 'HOME', path: '/' },
  { label: '회사소개', path: '/about' },
  { label: '사업영역', path: '/services' },
  { label: '채용정보', path: '/careers' },
  { label: '고객센터', path: '/contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  const isTransparent = isHome && !scrolled;

  return (
    <header className={`header ${scrolled ? 'header--scrolled' : ''} ${isTransparent ? 'header--transparent' : ''}`}>
      <div className="container header__inner">
        <Link to="/" className="logo">
          <img src="/logo.png" alt="주식회사 허브" className="logo__img" />
          <div className="logo__text">
            <span className="logo__kr">주식회사 허브</span>
            <span className="logo__en">HUB Co., Ltd.</span>
          </div>
        </Link>

        <nav className={`nav ${menuOpen ? 'nav--open' : ''}`}>
          {navItems.map(item => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav__item ${location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path)) ? 'nav__item--active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <button
          className={`hamburger ${menuOpen ? 'hamburger--open' : ''}`}
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="메뉴 열기"
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
